<div class="col-sm-12" *ngIf="!isEditLocation" style="height: 100%; padding: 5px 0;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
      <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
          <div class="col-sm-7 fiche-client" style="margin-top: 5px">
              <div> Locations supplémentaires </div>
          </div>
          <button class="uppercase" id="savecont" (click)="save()"> Enregistrer </button>
          <button class="uppercase btn-close" id="closeclt" (click)="fermer()"> Fermer </button>
      </div>
  </div>
  <div class="contente ligneBon col-sm-12" id="ContPlusPrest" style="color: #000; padding: 15px; font-size: 13px;">
      <div class="col-sm-12" style="padding: 15px 0px 15px 0px" [ngStyle]="{'height': heightTableau}">
          <ngx-datatable style="height: 100%" class="material" [rows]="listeLocationsSupplementaires || []" [columnMode]="'force'"
              [headerHeight]="30" [footerHeight]="0" [rowHeight]="30" [selectionType]="'checkbox'" [messages]="{emptyMessage: 'Pas de lignes à afficher'}"
              [loadingIndicator]="loadingIndicator" [selected]="selected">

              <ngx-datatable-column prop="dateDebut">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                      let-sort="sortFn">
                      <div class="tableheader">
                          <span class="uppercase"> Date début </span>
                      </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      {{value}}
                  </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column prop="heureDebut">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                      let-sort="sortFn">
                      <div class="tableheader">
                          <span class="uppercase"> Heure début </span>
                      </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      {{value}}
                  </ng-template>
              </ngx-datatable-column>
              
              <ngx-datatable-column prop="dateFin">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                      let-sort="sortFn">
                      <div class="tableheader">
                          <span class="uppercase"> Date fin </span>
                      </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      {{value}}
                  </ng-template>
              </ngx-datatable-column>
              <ngx-datatable-column prop="heureFin">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                      let-sort="sortFn">
                      <div class="tableheader">
                          <span class="uppercase"> Heure fin </span>
                      </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      {{value}}
                  </ng-template>
              </ngx-datatable-column>                
              
              <ngx-datatable-column prop="infosFact">
                  <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
                      let-sort="sortFn">
                      <div class="tableheader">
                          <span class="uppercase"> Info. fact </span>
                      </div>
                  </ng-template>
                  <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                      {{value}}
                  </ng-template>
              </ngx-datatable-column>                                
              
              <ngx-datatable-column [width]="80" [sortable]="false" [canAutoResize]="false" [draggable]="false"
                  [resizeable]="false">
                  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
                      <div class="text-center">
                          <button class="btn-detail" (click)="showFormEditLocation(row);">
                              <i class="fa fa-pencil"></i>
                          </button>
                          <button class="btn-detail" (click)="deleteLigne(row)">
                              <i class="fa fa-trash"></i>
                          </button>
                      </div>
                  </ng-template>
              </ngx-datatable-column>
          </ngx-datatable>
      </div>

      <div class="col-sm-12" style="padding: 15px 0px 15px 0px; margin-top: 10px">
          <div class="text-left">
              <button class="btn-add" id="addLigne" (click)="newFormEditLocation({});">
                  <i class="fa fa-plus"></i>
              </button>
              <span (click)="newFormEditLocation();">Ajouter</span>
          </div>
          <label class="text-left uppercase text-underline historique col-sm-5"></label>
      </div>        
  </div>
</div>

<div class="col-sm-12" *ngIf="isEditLocation && !isModeEquipe" style="height: 100%; padding: 5px 0;">
  <div class="fiche col-sm-12" style="padding: 2px 20px 5px 20px;">
      <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
          <div class="col-sm-7 fiche-client" style="margin-top: 5px">
              <div> {{ selectedLocation.id ? 'Modifier location' : 'Nouvelle location' }} </div>
          </div>
          <button class="uppercase" id="savecont" (click)="(common.getDiffDate(selectedLocation.dateStart, selectedLocation.dateEnd, false, true) < 0 || common.getDiffDate(selectedLocation.dateStart, selectedLocation.dateEnd, false, true) === 0 && testHour() < 0) ? false : saveLocation()"> Valider </button>
          <button class="uppercase btn-close" id="closeclt" (click)="fermerLocation()"> Annuler </button>
      </div>
  </div>
  
  <div class="contente ligneBon col-sm-12" style="color: #000;padding: 15px 0px 15px 0px; font-size: 13px;">
      <div class="col-sm-12" style="padding: 15px 0px 15px 0px">
          <span class="col-sm-12"> Début :
            <span style="margin-left: 250px;">{{common.isDate(selectedLocation.dateStart || '')}}</span>
          </span>
          
          <div class="col-sm-12">
            <app-input-date [class]="'col-sm-6 date'" [id]="'date1'" [model]="selectedLocation.dateStart"
              (changefct)="selectedLocation.dateStart = $event;" [placeholder]="'Date debut'"
              (blurfct)=" calculDate();changeDatePlanning('dateStart')"
              (keyenterfct)="common.changeDate($event, selectedLocation.dateStart, '#h1')"
              (selectfct)="selectDate($event, '#date1')" [showDatepicker]="true">
            </app-input-date>

            <input type="text" class="col-sm-2  col-sm-offset-1 inputtime" id="h1" placeholder="HH"
              (focus)="closeAll(d, d2);" [(ngModel)]="selectedLocation.hourStart" [onReturn]
              [ngClass]="{'inputtime-valid': selectedLocation.hourStart && selectedLocation.hourStart.length == 2}"
              autocomplete="off">

            <input type="text" class="inputtime col-sm-2 col-sm-offset-1" placeholder="MM"
              (focus)="closeAll(d, d2)" [(ngModel)]="selectedLocation.minStart" (ngModelChange)="changeHeureDebut()"
              [onReturn] (keydown.enter)="common.focusElement('#date2')"
              [ngClass]="{'inputtime-valid':selectedLocation.minStart && selectedLocation.minStart.length == 2}"
              autocomplete="off" (blur)="calculHour()">
              
            <app-input-date style="position: relative; top: 30px;" 
              [class]="'col-sm-6 date' + (common.getDiffDate(selectedLocation.dateStart, selectedLocation.dateEnd, false, true) < 0 ? ' error' : '')"
              [id]="'date2'" [model]="selectedLocation.dateEnd"
              (changefct)="selectedLocation.dateEnd = $event; selectedLocation.changeEnd = true;" [placeholder]="'Date fin'"
              (blurfct)=" changeDatePlanning('dateEnd')"
              (keyenterfct)="common.changeDate($event, selectedLocation.dateEnd, '#h2')"
              (selectfct)="selectedLocation.changeEnd = true;selectDate($event, '#date2')" [showDatepicker]="true">
            </app-input-date>

            <input type="text" class="inputtime col-sm-2 col-sm-offset-1" id="h2" placeholder="HH"
              (focus)="closeAll(d, d2)" [(ngModel)]="selectedLocation.hourEnd" style="margin-top: 30px"
              [ngClass]="{'inputtime-valid':selectedLocation.hourEnd && selectedLocation.hourEnd.length == 2, 'error': common.getDiffDate(selectedLocation.dateStart, selectedLocation.dateEnd, false, true) === 0 && testHour() < 0 }"
              [onReturn] autocomplete="off">

            <input type="text" class="inputtime col-sm-2 col-sm-offset-1" placeholder="MM"
              (focus)="closeAll(d, d2)" [(ngModel)]="selectedLocation.minEnd" style="margin-top: 30px"
              [ngClass]="{'inputtime-valid':selectedLocation.minEnd && selectedLocation.minEnd.length == 2,  'error': common.getDiffDate(selectedLocation.dateStart, selectedLocation.dateEnd, false, true) === 0 && testHour() < 0 }"
               autocomplete="off">
          </div>
      </div>
      
      <div class="col-sm-12" style="position: relative; bottom: 80px;">
        <span class="col-sm-12" style="padding-left: 0px;"> Fin :
          <span style="margin-left: 268px;">{{common.isDate(selectedLocation.dateEnd) || ''}}</span>
        </span>
      </div>
      
      <div class="col-sm-12 msgerror">
        <div class="col-sm-12" style="padding: 0px" *ngIf="common.getDiffDate(selectedLocation.dateStart, selectedLocation.dateEnd, false, true) < 0">
          La date de début est supérieur à la date de fin
        </div>
        <div class="col-sm-12"
          *ngIf="common.getDiffDate(selectedLocation.dateStart, selectedLocation.dateEnd, false, true) === 0 && testHour() < 0">
          L'heure de début est supérieure à l'heure de fin
        </div>
      </div>        

      <div style="height: 180px; padding: 13px"
        [ngStyle]="{'height': countRowsInText(selectedLocation.infosupp) > 3 ? '325px' : '180px'}">
      <div style="margin-bottom: 15px">
        <span class="step-title"> Informations </span>
      </div>          
        <div class="form-group" *ngIf="param.ecolocEquipe">
          <label style="padding-left: 0px;" (click)="showEquipeFct()">
            <span class='text-underline uppercase'> Modifier l'équipe </span></label>
        </div>          
        <div class="form-group">
          <label> Facturation </label>
          <input type="text" class="form-control info" placeholder="Facturation" autofocus id="infofact"
            [(ngModel)]="selectedLocation.infosFact" (keyup.enter)="nextFocus()" (focus)="selectedLocation.infofactfocus = true;"
            (blur)="selectedLocation.infofactfocus = false;" autocomplete="off">
        </div>
        <div class="form-group">
          <label> Supplém. </label>
          <textarea class="form-control" rows="{{countRowsInText(selectedLocation.infosSup)}}" id="infosup"
            placeholder="Supplém." [(ngModel)]="selectedLocation.infosSup" style="height: auto;"
            (focus)="selectedLocation.infosuppfocus = true;" (blur)="selectedLocation.infosuppfocus = false;"
            autocomplete="off"></textarea>
        </div>
      </div>        
  </div>        
</div>

<div class="ficheclt" *ngIf="isModeEquipe" 
  style="width: 750px; position: absolute; background-color: white; right: 0; top: 0;">
<app-equipe-ecoloc [mouvement]="objEquipe" [dateDebut]="selectedLocation.dateStart" [dateFin]="selectedLocation.dateEnd"
  [isHistoLoc]="false" (save)="saveEquipe($event)" (hidefunction)="showEquipeFct()"></app-equipe-ecoloc>
</div>    
<ng-template #msg>
  <div class="modal-body" style="height: auto">
      <div>
          <div class="col-sm-12">
              <strong class="cofirmemsg"> {{ error }} </strong>
          </div>
      </div>
      <div class="text-right" style="margin-top: 15px;">
          <button type="button" class=" btn-close btn-valider" (click)="common.closeModal()"> Fermer </button>
      </div>
  </div>
</ng-template>

<ng-template #templateSupressionFille>
<div class="modal-header">
  <h4 class="modal-title pull-left">Motif de suppression</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="common.closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" style="height: auto">
  <div class="col-sm-12 p-0" *ngIf="dataMotifSuppression && dataMotifSuppression.length">
    <div class="form-group items col-sm-12 p-0">
      <label class="col-sm-3 champ" style="padding:0px">
        Motif suppression :
      </label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <app-autocomplete [placeholder]="'Motif de suppression'" (selectfunction)="motifSuppression = $event;"
          [results]="dataMotifSuppression" [label]="''" id="modedepaie autoMotif" [disablefocus]="true"
          [isCombo]="true"
          [defaultsearch]="motifSuppression && motifSuppression.id ? motifSuppression.libelle || motifSuppression.libelleObjetEntite : ''"
          [dropdownclass]="'dropDownPrixNego'"></app-autocomplete>
      </div>
    </div>
  </div>
  <div class="col-sm-12 p-0" *ngIf="dataMotifSuppression && dataMotifSuppression.length">
    <div class="form-group items col-sm-12 p-0">
      <label class="col-sm-3 champ" style="padding:0px">
        Libelle :
      </label>
      <div class="col-sm-9 champ" style="padding-right: 0px">
        <input type="text" class="col-sm-12 form-control" [(ngModel)]="motifAnnulationFille"
          (keyup.enter)="confirmDeleteBonFille()" autofocus autocomplete="off" style="margin-bottom: 15px;">
      </div>
    </div>
  </div>
  <div class="col-sm-12 p-0" *ngIf="!dataMotifSuppression || (dataMotifSuppression && !dataMotifSuppression.length)">
    <input type="text" class="col-sm-12 form-control" [(ngModel)]="motifAnnulationFille"
      (keyup.enter)="confirmDeleteBonFille()" autofocus autocomplete="off" style="margin-bottom: 15px;">
  </div>

  <div class="text-right col-sm-12 p-0">
    <button type="button" class=" btn-close btn-valider" (click)="confirmDeleteBonFille()"> Valider</button>
    <button type="button" class=" btn-close" (click)="common.closeModal()"> Annuler</button>
  </div>
</div>
</ng-template>
